// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info-line_wrapper__3rFHY","title":"info-line_title__15U_Y","body":"info-line_body__GtVBm"};